var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.seletedPlugin != null && !_vm.isNewRegistrationMethod)?_c('iframe',{ref:"iframeExternalPluginReports",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"show-plugin","frameBorder":"0"}}):_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c(_vm.currentcomponent,{key:_vm.$route.fullPath,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }